// extracted by mini-css-extract-plugin
export default {"containerText":"Reasons_containerText__Iah7I","containerAvantaje":"Reasons_containerAvantaje__OE1gq"};